<template>
  <div class="score">
    {{stateShowFn}}
    <ul class="clear">
      <li v-for="item in stars">
        <span class="star" :class="score >= item.score?'starAc':''" @click="starsFn(item.score)"></span>
      </li>
    </ul>
    <div class="text" v-if="isShow">
      <p :class="score<=0?'textAsh':''">{{ msg }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'xk-star',
    props: {
      disabled: { // 是否能点击
        default () {
          return true
        }
      },
      isShow: {
        default () {
          return true
        }
      },
      state: {
        default () {
          return ''
        }
      },
      defScore: {
        default () {
          return 5
        }
      }
    },
    computed: {
      stateShowFn: function () {
        if (this.$props.state) {
          this.score = this.$props.defScore
          this.msg = this.stars[this.score - 1].msg
        }
      }
    },
    data () {
      return {
        stars: [
          {
            score: 1,
            msg: '非常不满意'
          }, {
            score: 2,
            msg: '不满意'
          }, {
            score: 3,
            msg: '一般'
          }, {
            score: 4,
            msg: '满意'
          }, {
            score: 5,
            msg: '非常满意'
          }
        ],
        msg: '请您对本次服务进行评价！', // 默认文字
        score: this.$props.defScore ? this.$props.defScore : 0, // 星级
        acState: this.$props.state === false ? this.$props.state : true
      }
    },
    methods: {
      starsFn: function (val) {
        if (this.disabled) {
          let that = this
          if (this.acState) {
            that.score = val
            switch (val) {
              case 1:
                that.msg = that.stars[(val - 1)].msg
                break
              case 2:
                that.msg = that.stars[(val - 1)].msg
                break
              case 3:
                that.msg = that.stars[(val - 1)].msg
                break
              case 4:
                that.msg = that.stars[(val - 1)].msg
                break
              case 5:
                that.msg = that.stars[(val - 1)].msg
                break
              default:
                that.msg = '请您对本次服务进行评价！'
            }
            that.$emit('clickChange', that.score) // 传给父级
          }
        }
      }
    },
    mounted: function () {
      let that = this
      if (this.$props.defScore && this.$props.defScore > 0) {
        this.msg = this.stars[(this.$props.defScore - 1)].msg
      }
      if (this.acState) {
        switch (that.score) {
          case 1:
            that.msg = that.stars[(that.score - 1)].msg
            break
          case 2:
            that.msg = that.stars[(that.score - 1)].msg
            break
          case 3:
            that.msg = that.stars[(that.score - 1)].msg
            break
          case 4:
            that.msg = that.stars[(that.score - 1)].msg
            break
          case 5:
            that.msg = that.stars[(that.score - 1)].msg
            break
          default:
            that.msg = '请您对本次服务进行评价！'
        }
        that.$emit('clickChange', that.score)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .score {
    display: inline-block;
    text-align: center;
    margin-top: 3.1666rem;
    ul {
      display: inline-block;
      li {
        float: left;
        margin: 0 0.625rem;
        span {
          width: 2rem;
          height: 2rem;
          transition: 0.3s all;
        }
        .star {
          background: url(../../../../assets/img/pingjia/xing.png) no-repeat center;
          background-size: 100% 100%;
        }
        .starAc {
          background: url(../../../../assets/img/pingjia/xingAc.png) no-repeat center;
          background-size: 100% 100%;
        }
      }
    }
    .text {
      font-size: 1rem;
      color: #f06553;
      margin-top: 0.823rem;
      .textAsh {
        color: #999999;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// star.vue?45691936